import Vue from 'vue';

import { get, post } from '../../request';

const state = () => ({
  payment: {},
  paymentPlans: [],
  isVerified: false,
  error: null,
});

const getters = {
};

const mutations = {
    error(s, e) {
      Vue.set(s, 'error', e);
    },
    setPayment(s, payment) {
      Vue.set(s, 'payment', payment);
    },
    setPaymentVerify(s, verify) {
      Vue.set(s, 'isVerified', verify);
    },
    setPaymentPlans(s, paymentPlan) {
      Vue.set(s, 'paymentPlans', paymentPlan);
    },
};

const actions = {
  async doStartPayment({ commit }, form) {
    commit('error', null);
    commit('setPaymentVerify', false);
    try {
      const data = await post('/payments/merchant/start', form, { commit });
      commit('setPayment', data);
    } catch (e) {
      commit('error', e);
    }
  },

  async doGetPaymentPlans({ commit }) {
    commit('error', null);
    commit('setPaymentVerify', false);
    try {
      const data = await get('/payments/merchant/payment_plans', { commit });
      commit('setPaymentPlans', data);
    } catch (e) {
      commit('error', e);
    }
  },

  async doStartPremiumPayment({ commit }, form) {
    commit('error', null);
    commit('setPaymentVerify', false);
    try {
      const data = await post('/payments/merchant/start_subscription_payment', form, { commit });
      commit('setPayment', data);
    } catch (e) {
      commit('error', e);
    }
  },

  async doVerifyPayment({ commit }, form) {
    commit('error', null);
    try {
      await post('/payments/merchant/verify', form, { commit });
      commit('setPaymentVerify', true);
    } catch (e) {
      commit('error', e);
    }
  },

  async doCancelPayment({ commit }, form) {
    commit('error', null);
    try {
      await post('/payments/merchant/cancel', form, { commit });
    } catch (e) {
      commit('error', e);
    }
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
